import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import UserIcon from '@material-ui/icons/AccountCircle';
import Colors from 'utils/colors';
import Avatar from '@material-ui/core/Avatar';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import { Link } from 'react-router-dom';
import Mixpanel from 'utils/mixpanelService';
import useDateLocale from 'components/useDateLocale';

const styles = theme => ({
  image: {
    width: 48,
    height: 48,
    borderRadius: '50%',
    [theme.breakpoints.down('600')]: {
      width: 70,
      height: 70,
    },
  },
  bigImage: {
    width: 80,
    height: 80,
    [theme.breakpoints.down('750')]: {
      width: 60,
      height: 60,
    },
    [theme.breakpoints.down('600')]: {
      width: 100,
      height: 100,
    },
  },
  root: {
    marginTop: 15,
    marginBottom: 15,
  },
  name: {
    fontSize: 13,
    color: Colors.link,
    fontWeight: 500,
  },
  role: {
    fontSize: 12,
    fontStyle: 'italic',
    fontWeight: 500,
  },
  profession: {
    fontSize: 12,
  },
  viewBio: {
    color: Colors.link,
    fontWeight: 500,
    cursor: 'pointer',
  },
  link: {
    textDecoration: 'none',
  },
  imageWrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
});

function redirectClickHandler(articleName, editorName) {
  Mixpanel.track('Article Page Editor - Clicked', {
    name: articleName,
    editorName,
  });
}

function Editor(props) {
  const { articleName, classes, data, publicationDate } = props;
  const dateFormatFilter = useDateLocale();
  return (
    <Grid item xs={12} className={classes.root}>
      <Grid container direction="row" spacing={2} justifyContent="flex-start">
        {data.map(item => {
          if (_isEmpty(_get(item, 'fields'))) return null;
          const { fields } = item;
          const hasImage = !_isEmpty(_get(fields, 'image.fields.file.url'));
          const file = hasImage && fields.image.fields.file.url;
          return (
            <React.Fragment key={fields.slug}>
              <Grid item xs={12} sm={6}>
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  justifyContent="flex-start"
                  spacing={2}
                >
                  <Grid item xs={3} className={classes.imageWrapper}>
                    {hasImage ? (
                      <Avatar
                        src={file}
                        className={classes.image}
                        alt="Editor"
                      />
                    ) : (
                      <UserIcon className={classes.image} />
                    )}
                  </Grid>
                  <Grid item xs={6}>
                    <Grid container>
                      <Grid item xs={12}>
                        <Link
                          to={`/editors/${fields.slug}`}
                          className={classes.link}
                          onClick={() =>
                            redirectClickHandler(articleName, fields.name)
                          }
                        >
                          <Typography className={classes.name}>
                            {fields.name}
                          </Typography>
                        </Link>
                      </Grid>
                      <Grid item xs={12}>
                        {!_isEmpty(publicationDate) && (
                          <Grid item xs={12}>
                            <Typography>
                              {format(
                                parseISO(publicationDate),
                                'MMM dd, yyyy',
                                {
                                  locale: dateFormatFilter,
                                },
                              )}
                            </Typography>
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </React.Fragment>
          );
        })}
      </Grid>
    </Grid>
  );
}

Editor.propTypes = {
  classes: PropTypes.object,
  data: PropTypes.array,
  articleName: PropTypes.string,
  publicationDate: PropTypes.object,
};

export default withStyles(styles)(Editor);
